import { Component, Input } from '@angular/core';

@Component({
	selector: 'button-secondary',
	template: require('./button-secondary.component.html'),
})
export class ButtonSecondaryComponent {
	@Input() title: string;
	@Input() size: string;
	@Input() isDisabled: boolean;
	@Input() iconName: string;
	@Input() iconClassName = 'icon-container-x-small';
	@Input() isError = false;
	@Input() hasMargin = true;
	@Input() fillSpaceMobile = false;
	@Input() otherClass: string;
	buttonClass: string;

	ngOnInit() {
		this.buttonClass = this.isError ? 'button-error' : 'button-secondary';
	}
}
